import { render, staticRenderFns } from "./ChannelSelector.vue?vue&type=template&id=f3586a32&scoped=true"
import script from "./ChannelSelector.vue?vue&type=script&lang=js"
export * from "./ChannelSelector.vue?vue&type=script&lang=js"
import style0 from "./ChannelSelector.vue?vue&type=style&index=0&id=f3586a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3586a32",
  null
  
)

export default component.exports